import api from '@config/api'
import { useQuery } from 'react-query'
import { useFormMutationHandler } from '@utils/useFormMutationHandler'
import { IFormMutationHandlerProps } from '@interfaces/default/IDefault'
import { useQueryConfig } from './useQueryConfig'

import {
    IRequestChangePassword,
    IRequestForgetPassword,
    IRequestSaveForgetPassword,
    IRequestUpdateProfile,
    IResponseGetProfile,
} from '@apiinterface/IAuth'

interface IUseUpdateProfile
    extends IFormMutationHandlerProps<IRequestUpdateProfile> {}

interface IUseChangeMyPassword
    extends IFormMutationHandlerProps<IRequestChangePassword> {}

interface IUseForgetPassword
    extends IFormMutationHandlerProps<IRequestForgetPassword> {}

interface IUseSaveForgetPassword
    extends IFormMutationHandlerProps<IRequestSaveForgetPassword> {
    withToken: string
}

const Auth = {
    useGetProfile: () =>
        useQuery(
            'useGetProfile',
            async () => {
                try {
                    const res = await api.get('/auth/profile')
                    return res.data.body as IResponseGetProfile
                } catch (error) {
                    return Promise.reject(error)
                }
            },
            useQueryConfig
        ),
    useUpdateProfile: ({ form, aftersuccess }: IUseUpdateProfile) => {
        return useFormMutationHandler({
            form,
            pathWithMethod: [`/auth/profile`, 'put'],
            aftersuccess,
        })
    },
    useChangePassword: ({ form, aftersuccess }: IUseChangeMyPassword) => {
        return useFormMutationHandler({
            form,
            pathWithMethod: [`/auth/changepassword`, 'post'],
            aftersuccess,
        })
    },

    useForgetPassword: ({ form, aftersuccess }: IUseForgetPassword) => {
        return useFormMutationHandler({
            pathWithMethod: [`/auth/forgotpassword`, 'post'],
            aftersuccess,
            form,
        })
    },
    useSaveForgetPassword: ({
        form,
        aftersuccess,
        withToken,
    }: IUseSaveForgetPassword) => {
        return useFormMutationHandler({
            withToken: withToken,
            pathWithMethod: [`/auth/forgotpassword`, 'put'],
            aftersuccess,
            form,
        })
    },
}

export default Auth
